var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 80",
    height: 80,
    width: 210,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #928980;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #331e11;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4cb0d3;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.01,
    y: 19.7,
    width: 73.58,
    height: 39.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.35,
    y: 19.99,
    width: 70.31,
    height: 39.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 186.91,
    y: 14.86,
    width: 3.32,
    height: 49.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.42,
    y: 8.47,
    width: 3.32,
    height: 5.36,
    transform: "translate(18.95 93.04) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 179.54,
    y: 66.51,
    width: 6.52,
    height: 3.32,
    transform: "translate(16.91 170.86) rotate(-52.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.61,
    y: 15.66,
    width: 17.4,
    height: 48.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.7 64.46 186.91 39.26 177.95 39.46 177.95 60.16 165.81 60.16 165.91 64.66 186.7 64.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.01,
    y: 60.86,
    width: 59.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.81,
    y: 60.86,
    width: 78.2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "185.94 14.76 186.04 39.96 177.48 39.76 177.48 19.06 165.81 19.06 165.91 14.56 185.94 14.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.35,
    y: 14.86,
    width: 59.46,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.31,
    y: 14.66,
    width: 78.2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.31,
    y: 16.96,
    width: 3.9,
    height: 45.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 191.91,
    y: 54.01,
    width: 1.1,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 192.51,
    y: 20.51,
    width: 1.1,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.01,63.51l1,1.2H29.01m-19-1.2l-1-1.2v-23m1,24.2l3-3.2m0-.1V18.71m0,41.5H29.01M13.01,18.71l-2.8-3.5m2.8,3.5H88.61M10.31,15.21l-1.2,1v23m1.2-24l1.2-1H88.51v4.5m0,0V60.21m0,0v4.5h-17.5m17.5-4.5h-17.5m-42,0v4.5m0-4.5h21.5m-21.5,4.5h42m-20.5-4.5v4m0-4h20.5m0,0v4.5M9.01,39.21h4.5m15.5-21v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.71,65.11l2.5-2,2,2,2-2,2,2,2-2,2,2,2-2,2,2.5m.3-.6v-4.5m0,4.5h17.5M105.51,14.01l-2.5,2.5-2-2.5-2,2.5-1.5-2.5-2.5,2.5-2.5-2.5-2,2.5-2-2m17-.5v5m0-5h17.5m63,0h3l2,2.5v2.5m-5-5v.5m0-.5h-4M105.51,60.51V19.01m0,41.5h17.5m54.5,0l8.5,4v-25m-8.5,21h-12.5m12.5,0v-21M105.51,19.01h17.5m53.5,0h1v20.5m-1-20.5l9.5-4.5m-9.5,4.5h-11.5m21-4.5v25m-21-20.5v-5m0,5h-22m22-5h-22m22,0h17m-39,5v-5m0,5h-20m20-5h-20m0,5v-5m0,46.5v4.5m0-4.5h20m-20,4.5h20m0-4.5v4.5m0-4.5h22m-22,4.5h39m-17-4.5v4m21-25h-8.5m13.5-20.5h3v7h-3m0-7v7m0,0v26.5m0,0h3v7h-3m0-7v7m0,0v3l-2,2.5h-2.5m-4.5-51l-2.5-5.5,3-.5,1.5,.5,2.5,5m0,51.5h-4.5m4.5,0l-2.5,6-2,1-2.5-1,2.5-6M92.39,19.51V59.51m4.57-40.05V59.46m4.89,.05V19.51m-44.34,14.5l2-2h16l2,2v11l-2,2h-16l-2-2s0-11,0-11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.29a85d157339183415e83bda7460ef0f.svg";
export { ForwardRef as ReactComponent };